'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var type = require('./type.js');

const DEFAULT_TITLE_FONT_SIZE = 14;
const DEFAULT_ARTICLE_LIST = {
  layout: "grid",
  categoryIds: [],
  gridConfig: {
    row: 2,
    column: 4,
    gutter: 16
  },
  listConfig: {
    row: 10,
    gutter: 16
  },
  showLoadMore: true,
  commonStyle: { color: "#000000", backgroundColor: "#ffffff" },
  displayConfig: {
    showAuthor: true,
    showDesc: true,
    showImage: true,
    showPublishDate: true,
    showTitle: true
  },
  loadMoreType: type.LoadMoreType.BUTTON,
  paginationColor: "#7367f0",
  isOpenNewTab: true,
  titleFontSize: DEFAULT_TITLE_FONT_SIZE,
  categoryColor: "#7367f0",
  categoryType: "button"
};
const DEFAULT_ARTICLE_THUMBNAIL = "https://lh3.googleusercontent.com/nAocrNg5Uz_6OlemCdHXyNfPK9uxJpBhADfy_xEc4QiZT7ihSAC_8X_wkht7FGoOxRWfT0IFtkaVxF6mKajLbLbueDZmdlg=rw-w500";

exports.DEFAULT_ARTICLE_LIST = DEFAULT_ARTICLE_LIST;
exports.DEFAULT_ARTICLE_THUMBNAIL = DEFAULT_ARTICLE_THUMBNAIL;
exports.DEFAULT_TITLE_FONT_SIZE = DEFAULT_TITLE_FONT_SIZE;
